import { Component, OnInit, OnChanges, SimpleChanges, Input, OnDestroy } from '@angular/core';
import { UserService } from '../../../services/core.user.service';
import { StateService, TransitionService as UIRouterTransitionService } from '@uirouter/angular';
import { UserHeaderService } from './user.header.service';
import { getAvatarUrl } from '../../../pipes/user/user.functions';

@Component({
  selector: 'user-header',
  template: require('./user.header.component.html'),
})
export class UserHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() user: any;

  currentState: string = '';
  subText: string = '';
  sameUser: boolean = false;
  private deregisterTransition?: Function;

  constructor(
    private userService: UserService,
    private userHeaderService: UserHeaderService,
    private stateService: StateService,
    private $transitions: UIRouterTransitionService
  ) {}

  ngOnInit(): void {
    this.currentState = this.stateService.current.name;
    this.subText = this.userHeaderService.getTitleForState(this.currentState);

    this.deregisterTransition = this.$transitions.onSuccess({}, (transition) => {
      const toName = transition.to().name;
      this.currentState = toName;
      this.subText = this.userHeaderService.getTitleForState(toName);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user && changes.user.currentValue) {
      this.sameUser = changes.user.currentValue.unixName === this.userService.session.getUnixName();
    }
  }

  ngOnDestroy(): void {
    if (this.deregisterTransition) {
      this.deregisterTransition();
    }
  }

  getAvatarUrlWrapper(user: any) {
    return getAvatarUrl(user);
  }
}
